import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { SessionHelper } from './sessionHelper';
import { untilDestroyed } from '@ngneat/until-destroy';
import { Auth } from '../models/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  personAuth: Auth[];

  constructor(private http:HttpClient) { }

  isAuthorized(action:string,entity:string){
    this.personAuth = JSON.parse(SessionHelper.getPersonAuth());
    if(
      this.personAuth && (
      this.personAuth.find(a => a.entityId == entity && a.type == action) || 
      this.personAuth.find(a => a.entityId == SessionHelper.getChoosenOrg() && a.type == 'orgedit') ||
      this.personAuth.find(a => a.entityId == 'admin' && a.type == 'et'))
      ){
      return true;
    }else{
      return false;
    }
  }
  // refreshPersonAuth(personId:string){
  //   if(SessionHelper.getChoosenOrg() != 'undefined' && SessionHelper.getChoosenOrg() != 'null' && SessionHelper.getChoosenOrg() != null && SessionHelper.getChoosenOrg() != ''){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     }),
  //     withCredentials: true
  //   }
  //   this.http.get<Auth[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId+'/auth',httpOptions).pipe(untilDestroyed(this)).subscribe(auth =>{
  //     SessionHelper.setPersonAuth(JSON.stringify(auth));
  //   });
  // }
  // }
  // getAccessToken(): Observable<string> {
  //   return from(Auth.currentSession()).pipe(
  //     switchMap(session => of(session.getIdToken().getJwtToken())
  //   ))
  // };
  
}
